import ClearIcon from '@material-ui/icons/Clear';
import FilterListIcon from '@material-ui/icons/FilterList';
import React, { useState } from 'react';
import './FilterPanel.css';
export const FilterPanel = ({ onClear, canClear = true, open, onOpenChange, children }) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = open !== undefined;
    const isOpen = isControlled ? open : internalOpen;
    const toggleOpen = () => {
        const next = !isOpen;
        if (!isControlled) {
            setInternalOpen(next);
        }
        onOpenChange?.(next);
    };
    return (React.createElement("div", { className: "filters__container" },
        React.createElement("div", { className: "filters", onClick: toggleOpen },
            React.createElement(FilterListIcon, { style: {
                    color: isOpen ? 'var(--color-purple)' : 'var(--color-grey)'
                } }),
            React.createElement("span", null, "Filter")),
        isOpen && (React.createElement("div", { className: "filter-panel__body u-margin-bottom-large" },
            children,
            React.createElement("div", { className: "filter-panel__footer" },
                React.createElement("button", { className: `filter-panel__clear${canClear ? '' : ' filter-panel__clear--off'}`, disabled: !canClear, onClick: () => {
                        onClear();
                    }, type: "button" },
                    React.createElement(ClearIcon, { style: { fontSize: '1.4rem' } }),
                    "Clear"))))));
};
